import { render } from "./kafka.vue?vue&type=template&id=0cffba3e"
import script from "./kafka.vue?vue&type=script&lang=js"
export * from "./kafka.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__